import state from './moduleDrillingState'
import mutations from './moduleDrillingMutations'
import actions from './moduleDrillingActions'
import getters from './moduleDrillingGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

